<script>
    export default {
        name: "ProductPrice",
        props: {
            oldPrice: Number,
            price: Number,
            discountCount: Number,
            isSmallSize: Boolean,
            isCardSize: Boolean,
        },
        computed: {
            isDiscount() {
                return this.discountCount;
            },
        },
    };
</script>

<template>
    <div
        class="product-price"
        :class="{
            'product-price--sm': isSmallSize,
            'product-price--card': isCardSize,
        }"
    >
        <div class="product-price__wrap">
            <div
                class="product-price__number product-price__number--current"
                :class="{
                    'product-price__number--discount': isDiscount,
                }"
            >
                {{ price | formatPrice }}&nbsp;₽
            </div>
            <div v-if="isDiscount" class="product-price__number product-price__number--old">
                {{ oldPrice | formatPrice }}&nbsp;₽
            </div>
        </div>
        <div v-if="isDiscount" class="product-price__label">-{{ discountCount }}%</div>
    </div>
</template>

<style lang="scss">
    .product-price {
        position: relative;
        display: flex;
        align-items: center;
    }

    .product-price__label {
        width: 48px;
        height: 22px;
        margin-left: 14px;
        color: #fff;
        font-size: 14px;
        font-weight: 800;
        line-height: 18px;
        text-align: center;
        background: var(--secondary);
        border: 2px solid #fff;
        border-radius: 8px;
        @include bp($bp-desktop-sm) {
            width: 56px;
            height: 28px;
            font-size: 16px;
            line-height: 22px;
            border-radius: 10px;
        }
    }

    .product-price__wrap {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
    }

    .product-price__number {
        color: var(--primary-text);
        font-size: 18px;
        line-height: 26px;
        font-weight: 700;
        @include bp($bp-desktop-sm) {
            font-size: 32px;
            line-height: 36px;
        }
    }

    //
    // --mod
    //

    .product-price__number--current {
        margin-right: 8px;
    }

    .product-price__number--discount {
        color: var(--secondary);
    }

    .product-price__number--old {
        color: var(--primary-text);
        font-size: 14px;
        font-weight: 400;
        text-decoration: line-through;
        @include bp($bp-desktop-sm) {
            font-size: 16px;
        }
    }

    .product-price--sm {
        .product-price__number {
            font-size: 12px;
            line-height: 18px;
        }

        .product-price__number--old {
            font-size: 10px;
        }

        .product-price__label {
            width: 38px;
            height: 18px;
            margin-left: 10px;
            font-size: 10px;
            line-height: 14px;
        }
    }

    .product-price--card {
        .product-price__number {
            font-size: 14px;
            line-height: 20px;

            @include bp($bp-desktop-sm) {
                font-size: 22px;
                line-height: 28px;
            }
        }

        .product-price__number--old {
            font-size: 10px;
            line-height: 12px;
            margin-bottom: 2px;

            @include bp($bp-desktop-sm) {
                font-size: 14px;
                line-height: 18px;
            }
        }

        .product-price__label {
            width: 36px;
            height: 18px;
            color: var(--secondary);
            font-size: 12px;
            font-weight: 600;
            line-height: 14px;
            background-color: #fff;
            border-color: var(--secondary);
            @include bp($bp-desktop-sm) {
                width: 52px;
                height: 24px;
                font-size: 16px;
                line-height: 20px;
            }
        }
    }
</style>
